const removeMarks = (string) => {
  return string.replace(/(<mark[^>]+?>|<mark>|<\/mark>)/gim, '');
};

export { removeMarks };
